const tailwindColors = {
  darkestPurple: '#46326e',
  darkerPurple: '#230067',
  purple: '#582ea9',
  medPurple: '#6600b5',
  darkerPurple2: '#5b23ac',
  brightPurple: '#9013fe',
  primary: '#3d8cb8',
  success: '#27ae60',
  danger: {
    DEFAULT: '#eb5656',
    500: '#eb5656',
  },
  black: '#000000',
  white: '#ffffff',
  transparent: 'transparent',
  current: 'currentColor',
  cblogo: '#ff3300',
  toggleGreen: '#50e3c2',
  link: '#1241E7',
  // legacyorange: the pre-migration cbrwarn orange, preserved as an intentional
  // named token for the Predictive churn-risk "Medium" level. Sting has no orange
  // and brand-logo (#ff3300) reads as red, so this keeps a true orange middle in the
  // High/Medium/Low traffic light. Temporary - revisit when a Sting orange exists.
  legacyorange: {
    50: '#feefe7',
    100: '#fbceb6',
    200: '#f9ad86',
    300: '#f68d55',
    400: '#f46c25',
    500: '#da530b',
    600: '#aa4009',
    700: '#792e06',
    800: '#491c04',
    900: '#180901',
  },
  'pricingtable-brand': 'rgb(var(--color-pricingtable-brand) / <alpha-value>)',
  'pricingtable-accent':
    'rgb(var(--color-pricingtable-accent) / <alpha-value>)',
  'pricingtable-background':
    'rgb(var(--color-pricingtable-background) / <alpha-value>)',
  'pricingtable-text-contrast':
    'rgb(var(--color-pricingtable-text-contrast) / <alpha-value>)',
  'pricingtable-text-base':
    'rgb(var(--color-pricingtable-text-base) / <alpha-value>)',

  'pricing-editor-link': {
    light: 'rgb(var(--color-link-light) / <alpha-value>)',
    dark: 'rgb(var(--color-link-dark) / <alpha-value>)',
  },

  // TODO: cleanup the code once theme is finalized
  'pricing-editor-brand': {
    50: '#e5f3fa', // cbrprimary-50
    100: '#b5def0', // cbrprimary-100
    200: '#8ccce6', // cbrprimary-200
    300: '#68badf', // cbrprimary-300
    400: '#4da8d5', // cbrprimary-400
    500: '#3d8cb8', // cbrprimary-500
    600: '#2d6a8a', // cbrprimary-600
    700: '#1d485f', // cbrprimary-700
    800: '#012a38', // cbrprimary-800
    900: '#040f13', // cbrprimary-900
  },
  'pricing-editor-primary': {
    50: '#e5f3fa', // cbrprimary-50
    100: '#b5def0', // cbrprimary-100
    200: '#8ccce6', // cbrprimary-200
    300: '#68badf', // cbrprimary-300
    400: '#4da8d5', // cbrprimary-400
    500: '#3d8cb8', // cbrprimary-500
    600: '#2d6a8a', // cbrprimary-600
    700: '#1d485f', // cbrprimary-700
    800: '#012a38', // cbrprimary-800
    900: '#040f13', // cbrprimary-900
  },
  'pricing-editor-neutral': {
    50: '#f4f5f7', // cbrneutral-50
    100: '#eaecee', // cbrneutral-100
    200: '#d6dadf', // cbrneutral-200
    300: '#bac1c9', // cbrneutral-300
    400: '#96a0ac', // cbrneutral-400
    500: '#6e7a87', // cbrneutral-500
    600: '#4d5966', // cbrneutral-600
    700: '#374049', // cbrneutral-700
    800: '#21262c', // cbrneutral-800
    900: '#0b0d0f', // cbrneutral-900
  },
  'pricing-editor-danger': {
    50: '#fce9e9', // cbrdanger-50
    100: '#f5bdbc', // cbrdanger-100
    200: '#ee9190', // cbrdanger-200
    300: '#e86564', // cbrdanger-300
    400: '#e13837', // cbrdanger-400
    500: '#c81f1e', // cbrdanger-500
    600: '#9b1817', // cbrdanger-600
    700: '#6f1111', // cbrdanger-700
    800: '#430a0a', // cbrdanger-800
    900: '#160303', // cbrdanger-900
  },
  'pricing-editor-warning': {
    50: '#feefe7', // cbrwarn-50
    100: '#fbceb6', // cbrwarn-100
    200: '#f9ad86', // cbrwarn-200
    300: '#f68d55', // cbrwarn-300
    400: '#f46c25', // cbrwarn-400
    500: '#da530b', // cbrwarn-500
    600: '#aa4009', // cbrwarn-600
    700: '#792e06', // cbrwarn-700
    800: '#491c04', // cbrwarn-800
    900: '#180901', // cbrwarn-900
  },
  'pricing-editor-success': {
    50: '#ecf9ee', // cbrsuccess-50
    100: '#c5eccd', // cbrsuccess-100
    200: '#9fe0ac', // cbrsuccess-200
    300: '#78d38a', // cbrsuccess-300
    400: '#52c769', // cbrsuccess-400
    500: '#38ad4f', // cbrsuccess-500
    600: '#297f3a', // cbrsuccess-600
    700: '#1f602c', // cbrsuccess-700
    800: '#133a1a', // cbrsuccess-800
    900: '#061309', // cbrsuccess-900
  },
};

module.exports = tailwindColors;
